import { render, staticRenderFns } from "./DeniedNotification.html?vue&type=template&id=7d920af3&scoped=true&"
import script from "./DeniedNotification.js?vue&type=script&lang=js&"
export * from "./DeniedNotification.js?vue&type=script&lang=js&"
import style0 from "./DeniedNotification.scss?vue&type=style&index=0&id=7d920af3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d920af3",
  null
  
)

export default component.exports